import * as D from 'io-ts/lib/Decoder'
import { populated } from './Populated'
import { PassTierDecoder } from './PassTier'

export const AccessCodeDecoder = D.intersection(
    D.type({
        _id: D.string,
        createdAt: D.string,
        show: D.string,
        redemptionCode: D.string,
        email: D.string,
        isRedeemed: D.boolean,
        redeemedAt: D.string,
        updatedAt: D.string,
    }),
    D.partial({
        promoCode: D.string,
        passTier: populated(PassTierDecoder),
        passTierFormValues: D.array(D.string),
    }),
)

export interface AccessCode extends D.TypeOf<typeof AccessCodeDecoder> {}
